import React from "react";
import OperatingSystemUtility from "./utilities/OperatingSystemUtility";

export default class MobileShort extends React.Component {

      public componentDidMount(): void {
            if (OperatingSystemUtility.isAndroid()) {
                  window.location.href = "https://play.google.com/store/apps/details?id=com.playreverser.reachthepet&utm_source=tg667&utm_campaign=inf&utm_medium=instagram";
            } else if (OperatingSystemUtility.isIOS()) {
                  window.location.href = "https://apps.apple.com/us/app/reach-the-pet/id6499559354?itsct=apps_box_link&itscg=30200&utm_source=tg667&utm_campaign=inf&utm_medium=instagram";
            }
      }

      public render(): React.ReactNode {
            return <></>;
      }
}